import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';

const Spinner = ({ size = 24, color = 'inherit' }) => (
  <Spin indicator={<LoadingOutlined style={{ fontSize: size, color: color }} spin />} />
);

export default Spinner;
